<template>
  <div class="innermodaloverflow">
    <div
      v-for="(addon, index) in selectedAddons"
      :key="index"
      class="addonlistdiv"
    >
      <label class="font-regular-16 btm-1">
        Add-on "<strong>{{ addon.productName }}</strong
        >" assignment status:
      </label>
      <div class="userlistdiv">
        <div
          v-for="(item, index) in getResponsesByProductId(
            addon.productBucketId
          )"
          :key="index"
        >
          <p
            v-if="item.status"
            class="font-regular-16 breaking-words success-text"
          >
            {{ item.userEmail }} was assigned successfully.
          </p>
          <p
            v-if="!item.status"
            class="font-regular-16 breaking-words failure-text"
          >
            {{ item.userEmail }} assignment failed: {{ item.error }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.success-text {
  color: #379e14;
}
.failure-text {
  color: #df444d;
}
</style>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import {
  ProductInfomation,
  AddonInformation,
  ApiAssignEntitlementsToUsersResponse,
} from "@/utils/AppInterfaces";

export default defineComponent({
  name: "AssignAddonsResultModal",
  computed: {},
  data() {
    return {
      product: this.assignedProduct || ({} as ProductInfomation),
      detailsOf: this.dataof,
    };
  },
  methods: {
    getValidationErrorMessage(validationMessages?: string[] | null) {
      if (!Array.isArray(validationMessages) || !validationMessages.length) {
        return "";
      }

      const firstMessage = validationMessages[0] || "";
      const messageParts = firstMessage.split(":");

      if (messageParts.length < 2) {
        return firstMessage;
      }

      return messageParts.slice(1).join(":").trim();
    },

    getResponsesByProductId(productId: string) {
      if (
        !this.assignAddonsResult ||
        !Array.isArray(this.assignAddonsResult.responses)
      ) {
        return [];
      }
      const failedRows = this.assignAddonsResult.responses.flatMap((r) =>
        r.assignmentResponses
          .filter((ar) => ar.productBucketId === productId)
          .map((ar) => ({
            userEmail: r.userEmail,
            userName: r.userName,
            status: ar.success,
            error: this.getValidationErrorMessage(
              ar.validationResult?.validationMessages
            ),
          }))
      );
      return failedRows;
    },
  },
  props: {
    assignAddonsResult: {
      type: Object as PropType<ApiAssignEntitlementsToUsersResponse>,
      required: false,
    },
    selectedAddons: {
      type: Array as PropType<AddonInformation[]>,
      required: false,
    },
  },
});
</script>
